module.exports = __webpack_public_path__ + "img/03.2e12cd0d.jpg";